import OffersSlider from '@/lib/widgets/main-page/we-build-ourselves/OffersSlider/OffersSlider';

import { IMainPage } from '@/lib/entities/page';

import { H1 } from '@/lib/shared/components/Typography';

import { useTranslation } from 'next-i18next';

import styles from './ValuesSlider.module.scss';

interface IValuesSlider {
  data: IMainPage;
}
export const ValuesSlider = ({ data }: IValuesSlider) => {
  const { t } = useTranslation('index', { keyPrefix: 'about' });
  return (
    <div className={styles.container}>
      <div className={styles.values}>
        <H1 as={'h2'}>{t('weImplementValues')}</H1>

        <OffersSlider data={data} theme="dark" />
      </div>
    </div>
  );
};
